import { IApplicationState } from '../../types/redux';

export function getReviewIds(state: IApplicationState) {
  return state.reviews.allIds;
}
